module.exports = __webpack_public_path__ + "img/FR11998.609e208e.png";